import React, { memo,useEffect } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import useProductCategory from "../../hooks/useProductCategory";

const CategoryListHome = () => {
    const {
        fetchProductCategory,
        data: productCategory,
        status: productCategoryStatus,
        error: productCategoryError,
    } = useProductCategory();

    useEffect(() => {
        fetchProductCategory();
    }, []);

    const chunk = (arr, size) => {
        const out = [];
        for (let i = 0; i < arr.length; i += size) {
            out.push(arr.slice(i, i + size));
        }
        return out;
    };

    if (!productCategory || productCategory.length === 0) return null;
      // 1️⃣ Take the first item for Slide #1 (bottom position)
        const [firstItem, ...rest] = productCategory;

        // 2️⃣ Chunk the remaining items in pairs (top + bottom)
        const pairs = chunk(rest, 2);


    const SampleNextArrow = memo((props) => {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    });
    
    const SamplePrevArrow = memo((props) => {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    });
            
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: false,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },

        ],
    };

    return (
        
        <section className="recommended mt-40">
            <div className="container container-md">
                <div className="feature-item-wrapper">
                    {/* <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/all-product.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="" style={{ fontSize: "1rem"}}>
                                    ALL CATEGORY
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div> */}
                    {
                        // Array.isArray(productCategory) &&
                        // productCategory.length > 0 && (

                        Array.isArray(pairs) &&
                        pairs.length > 0 && (
                            <Slider {...settings}>

                                    {
                                        
                                        <div key={0}>
                                            <div className="feature-item text-center">
                                                <div className="feature-item__thumb all rounded-circle">
                                                    <Link to="/products" className="w-100 h-100 flex-center">
                                                        <img src="assets/images/icon/all-product.png" alt="" />
                                                    </Link>
                                                </div>
                                                <div className="feature-item__content mt-16">
                                                    <h6 className="feature-item__title mb-8">
                                                        <Link to="/products" className="" style={{ fontSize: "1rem"}}>
                                                            ALL CATEGORY
                                                        </Link>
                                                    </h6>
                                                    <span className="feature-item__desc text-gray-400">125+ Products</span>
                                                </div>
                                            </div>
                                        
                                            <div className="feature-item text-center" key={0}>
                                                <div className="feature-item__thumb rounded-circle">
                                                    <Link to={`/products?category=${firstItem.id}`} className="w-100 h-100 flex-center">
                                                        <img style={{ maxWidth: "70%" }} src={firstItem.imageData?.url || "assets/images/no-image.png"} alt="" />
                                                    </Link>
                                                </div>
                                                <div className="feature-item__content mt-16">
                                                    <h6 className="feature-item__title mb-8">
                                                        <Link to={`/products?category=${firstItem.id}`} className="" style={{ fontSize: "1rem"}}>
                                                            {firstItem.name}
                                                        </Link>
                                                    </h6>
                                                    <span className="feature-item__desc text-gray-400">125+ Products</span>
                                                </div>
                                            </div> 
                                        </div>
                                        
                                    }
                                    
                            {
                                
                                // productCategory.map((item, index) => (
                                pairs.map((item, index) => (
                                   
                                    <div key={index + 1}> 
                                       
                                        {
                                            item[0] != undefined && (
                                            <div className="feature-item text-center" >
                                                <div className="feature-item__thumb rounded-circle">
                                                    <Link to={`/products?category=${item[0].id}`} className="w-100 h-100 flex-center">
                                                        <img style={{ maxWidth: "70%" }} src={item[0].imageData?.url || "assets/images/no-image.png"} alt="" />
                                                    </Link>
                                                </div>
                                                <div className="feature-item__content mt-16">
                                                    <h6 className="feature-item__title mb-8">
                                                        <Link to={`/products?category=${item[0].id}`} className="" style={{ fontSize: "1rem"}}>
                                                            {item[0].name}
                                                        </Link>
                                                    </h6>
                                                    <span className="feature-item__desc text-gray-400">125+ Products</span>
                                                </div>
                                            </div>
                                            )
                                        }
                                        
                                        {
                                            item.length > 1 && (
                                                <div className="feature-item text-center" >
                                                    <div className="feature-item__thumb rounded-circle">
                                                        <Link to={`/products?category=${item.id}`} className="w-100 h-100 flex-center">
                                                            <img style={{ maxWidth: "70%" }} src={item[1].imageData?.url || "assets/images/no-image.png"} alt="" />
                                                        </Link>
                                                    </div>
                                                    <div className="feature-item__content mt-16">
                                                        <h6 className="feature-item__title mb-8">
                                                            <Link to={`/products?category=${item[1].id}`} className="" style={{ fontSize: "1rem"}}>
                                                                {item[1].name}
                                                            </Link>
                                                        </h6>
                                                        <span className="feature-item__desc text-gray-400">125+ Products</span>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        
                                    </div>

                                    
                                ))
                            }
                            </Slider>
                        )
                    }
                    
                    
                    {/* <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/drink-beverages.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Drinks & Beverages
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/all-time-pastry.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    All Time Pastry
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/health-wellness.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Health & Wellness
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/baby-child.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Baby & Child
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/baking-needs.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Baking Needs
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/breakfast.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Breakfast & Cereal
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/canned-food.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Canned Foods
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/chillie.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Chili Sauce & Condiments
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/cooking-ingridient.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Cooking Ingridients
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/cracker-snack.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Cracker Snack & Cookies
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/dairy-product.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Dairy Products
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/dried-food.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Dried Food
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/frozen-food.png" style={{ width: "80%", height: "80%", objectFit: "contain" }} alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Frozen Food & Fresh Food
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/milk-powder.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Milk Powder
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div>
                    <div className="feature-item text-center">
                        <div className="feature-item__thumb rounded-circle">
                            <Link to="/products" className="w-100 h-100 flex-center">
                                <img src="assets/images/icon/seasonal-food.png" alt="" />
                            </Link>
                        </div>
                        <div className="feature-item__content mt-16">
                            <h6 className="feature-item__title mb-8">
                                <Link to="/products" className="text-inherit">
                                    Seasonal Speciality Food
                                </Link>
                            </h6>
                            <span className="feature-item__desc text-gray-400">125+ Products</span>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>

    )
}

export default CategoryListHome